import { render, staticRenderFns } from "./rongZiXinXi.vue?vue&type=template&id=52becb74&"
import script from "./rongZiXinXi.vue?vue&type=script&lang=js&"
export * from "./rongZiXinXi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports